"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Nav = Nav;
var react_1 = __importStar(require("react"));
var user_ctx_1 = require("../contexts/user_ctx");
function LogoutButton() {
    var userLogout = (0, react_1.useContext)(user_ctx_1.UserContext).userLogout;
    function handleClick() {
        userLogout();
        // window.location.reload();
    }
    return (react_1.default.createElement("button", { className: "zmsk-button", onClick: handleClick }, "Logout"));
}
function Nav() {
    var userinfo = (0, react_1.useContext)(user_ctx_1.UserContext).userinfo;
    console.log(userinfo, "userinfo");
    return (react_1.default.createElement("div", { className: "zmsk-nav" },
        react_1.default.createElement("h1", null, "\u7B2C\u4E00\u5065\u5EB7\u7ED3\u679C\u7BA1\u7406"),
        react_1.default.createElement("div", null,
            react_1.default.createElement("span", { className: "welcome" },
                "Welcome,",
                react_1.default.createElement("span", { className: "nickname" },
                    userinfo.nickname,
                    ".")),
            react_1.default.createElement(LogoutButton, null))));
}
